import TaskTemplateDomainService from "../TaskTemplate/TaskTemplate.service";
export default class ActionPlanTemplateDomainService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { createdDate: new Date(json.createdDate), modifiedDate: new Date(json.modifiedDate), templates: json === null || json === void 0 ? void 0 : json.templates.map(TaskTemplateDomainService.fromJSON) });
    }
}
